<x-shop-dialog
  i18n-heading="@@Error.OrderPartiallyPaid.Heading"
  heading="Order is Partially Paid"
  i18n-subheading="@@Error.OrderPartiallyPaid.Subheading"
  subheading="You need to complete the payment for this order. Contact support for further assistance."
  [canClose]="true"
  (closeDialog)="closeDialog()"
>
  <x-shop-dialog-actions>
    <button
      xAction
      type="button"
      mat-stroked-button
      xNeedHelp
      color="primary"
      i18n="@@CallToAction.NeedHelp"
    >
      Need Help?
    </button>
    <button
      mat-flat-button
      color="primary"
      xAction
      (click)="closeDialog()"
      i18n="@@CallToAction.Continue"
    >
      Continue
    </button>
  </x-shop-dialog-actions>
</x-shop-dialog>
